import { render, staticRenderFns } from "./BasicCardList.vue?vue&type=template&id=77787e22&scoped=true"
import script from "./BasicCardList.vue?vue&type=script&lang=ts"
export * from "./BasicCardList.vue?vue&type=script&lang=ts"
import style0 from "./BasicCardList.vue?vue&type=style&index=0&id=77787e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77787e22",
  null
  
)

export default component.exports